import { React, useEffect, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useHistory } from "react-router-dom";
import { LoaderScreen } from "../../components/LoaderScreen";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { FormatMoney } from "../../../Helpers/FormatNumber";

export const DashboardOTAbiertasScreen = () => {
    const history = useHistory();
    const [datos, setDatos] = useState(null);
    const [expandido, setExpandido] = useState(null);
    const [loader, setLoader] = useState({
        mostrar: false, alerta: false, error: false, mensaje: "",
    });

    useEffect(() => {
        GetDatos();
    }, []);

    const GetDatos = async () => {
        setLoader((prev) => ({ ...prev, mostrar: true }));
        try {
            const result = await request.get(`DashboardOTAbiertas/ObtenerOrdenesAbiertas`);
            setDatos(result);
            setLoader((prev) => ({ ...prev, mostrar: false }));
        } catch {
            setLoader((prev) => ({ ...prev, mostrar: false }));
            Swal.fire("Error", "Ocurrió un error al cargar la información.", "error");
        }
    };

    const FormatKm = (valor) => `${Number(valor || 0).toLocaleString("es-MX")} km`;

    const onVerSucursal = (e, row) => {
        e.stopPropagation();
        history.push("/PostVenta/OrdenTrabajoAbiertaSucursal", {
            sucursal: row.idsucursal,
            nombreSucursal: row.sucursal,
        });
    };

    const toggleExpandir = (idsucursal) => {
        setExpandido((prev) => (prev === idsucursal ? null : idsucursal));
    };

    return (
        <div className="ota-main-screen">
            <LoaderScreen loader={loader} />

            <div className="ota-body">
                <div className="ota-page">
                    <div className="ota-module">

                        {/* ── Header del módulo ─────────────────────────────────── */}
                        <div className="ota-module-head">
                            <div className="ota-head-grid">

                                <div className="ota-head-left">
                                    <button
                                        className="ota-btn-secondary ota-btn-amarillo"
                                        onClick={() => window.history.back()}
                                    >
                                        <ArrowBackIcon fontSize="small" /> Regresar
                                    </button>
                                </div>

                                <div className="ota-head-center">
                                    <h1 className="ota-title">DASHBOARD OT ABIERTAS</h1>
                                    <p className="ota-head-period">Órdenes de trabajo abiertas por sucursal</p>
                                </div>

                                <div className="ota-head-right" />
                            </div>

                            <div className="ota-head-divider">
                                <div className="ota-head-divider-dot" />
                            </div>
                        </div>

                        {/* ── Tarjetas resumen (dashboard) ──────────────────────── */}
                        {datos?.resumen && (
                            <div className="ota-kpis">
                                <div className="ota-kpi-card">
                                    <span className="ota-kpi-label">Órdenes abiertas</span>
                                    <span className="ota-kpi-value">{datos.resumen.ordenes_Abiertas}</span>
                                </div>
                                <div className="ota-kpi-card ota-kpi-green">
                                    <span className="ota-kpi-label">En tiempo</span>
                                    <span className="ota-kpi-value">{datos.resumen.green}</span>
                                </div>
                                <div className="ota-kpi-card ota-kpi-yellow">
                                    <span className="ota-kpi-label">Por vencer</span>
                                    <span className="ota-kpi-value">{datos.resumen.yellow}</span>
                                </div>
                                <div className="ota-kpi-card ota-kpi-red">
                                    <span className="ota-kpi-label">Vencidas</span>
                                    <span className="ota-kpi-value">{datos.resumen.red}</span>
                                </div>
                                <div className="ota-kpi-card">
                                    <span className="ota-kpi-label">Antigüedad máxima</span>
                                    <span className="ota-kpi-value">{datos.resumen.max_antiguedad}</span>
                                    <span className="ota-kpi-meta">días</span>
                                </div>
                            </div>
                        )}

                        {/* ── Tabla plana de detalle por sucursal ───────────────── */}
                        {datos?.detalle && (
                            <div className="ota-tabla-section">
                                <div className="ota-tabla-head">
                                    <div></div>
                                    <div>Sucursal</div>
                                    <div>Órdenes abiertas</div>
                                    <div>Semáforo</div>
                                    <div>Antigüedad máx.</div>
                                    <div>Mano de obra</div>
                                    <div>Refacciones</div>
                                    <div>Trabajos foráneos</div>
                                    <div>Kilometraje</div>
                                    <div>Total</div>
                                </div>

                                {datos.detalle.map((r, index) => {
                                    const esTotal = r.sucursal?.toUpperCase() === "TOTAL";
                                    const abierto = expandido === r.idsucursal;
                                    const tipos = (datos.detalleTipo || []).filter(
                                        (t) =>
                                            t.idsucursal === r.idsucursal &&
                                            (Number(t.mano_obra) ||
                                                Number(t.refacciones) ||
                                                Number(t.trabajos_foraneos) ||
                                                Number(t.kilometraje) ||
                                                Number(t.total))
                                    );
                                    return (
                                        <div key={index} className="ota-tabla-group">
                                            <div
                                                className="ota-tabla-row ota-tabla-row-clickable"
                                                onClick={() => toggleExpandir(r.idsucursal)}
                                            >
                                                <div className="ota-cell-ver">
                                                    {!esTotal && (
                                                        <VisibilityIcon
                                                            fontSize="small"
                                                            onClick={(e) => onVerSucursal(e, r)}
                                                        />
                                                    )}
                                                </div>
                                                <div className="ota-cell-sucursal">{r.sucursal}</div>
                                                <div className="ota-cell-num">{r.ordenes_Abiertas}</div>
                                                <div className="ota-cell-semaforo">
                                                    <span className="ota-badge ota-badge-green">{r.green}</span>
                                                    <span className="ota-badge ota-badge-yellow">{r.yellow}</span>
                                                    <span className="ota-badge ota-badge-red">{r.red}</span>
                                                </div>
                                                <div className="ota-cell-num">{r.max_antiguedad}</div>
                                                <div className="ota-cell-importe">{FormatMoney(r.mano_obra, 2)}</div>
                                                <div className="ota-cell-importe">{FormatMoney(r.refacciones, 2)}</div>
                                                <div className="ota-cell-importe">{FormatMoney(r.trabajos_foraneos, 2)}</div>
                                                <div className="ota-cell-num">{FormatKm(r.kilometraje)}</div>
                                                <div className="ota-cell-importe">{FormatMoney(r.total, 2)}</div>
                                            </div>

                                            {abierto && (
                                                <div className="ota-subtabla">
                                                    <div className="ota-subtabla-head">
                                                        <div>Tipo</div>
                                                        <div>Mano de obra</div>
                                                        <div>Refacciones</div>
                                                        <div>Trabajos foráneos</div>
                                                        <div>Kilometraje</div>
                                                        <div>Total</div>
                                                    </div>
                                                    {tipos.length > 0 ? (
                                                        tipos.map((t, i) => (
                                                            <div key={i} className="ota-subtabla-row">
                                                                <div className="ota-cell-tipo">{t.v_tipo}</div>
                                                                <div className="ota-cell-importe">{FormatMoney(t.mano_obra, 2)}</div>
                                                                <div className="ota-cell-importe">{FormatMoney(t.refacciones, 2)}</div>
                                                                <div className="ota-cell-importe">{FormatMoney(t.trabajos_foraneos, 2)}</div>
                                                                <div className="ota-cell-num">{FormatKm(t.kilometraje)}</div>
                                                                <div className="ota-cell-importe">{FormatMoney(t.total, 2)}</div>
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <div className="ota-subtabla-empty">Sin desglose para esta sucursal.</div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        )}

                        {/* ── Estado vacío ──────────────────────────────────────── */}
                        {!loader.mostrar && !datos?.detalle && (
                            <div className="ota-empty-state">
                                <p>No hay información disponible.</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DashboardOTAbiertasScreen;

